export const InfoTooltip = ({ className = "" }) => (
    <span className={`ml-1 inline-flex items-center justify-center w-[12px] h-[12px] rounded-full border border-[#180A63] text-[#180A63] text-[10px] font-semibold leading-none ${className}`}>?</span>
  );